/**
 * 微信分享工具类
 */

// 加载微信 JS-SDK (如果尚未加载)
const loadWxSDK = () => {
  return new Promise((resolve, reject) => {
    if (window.wx) {
      resolve(window.wx);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
    script.onload = () => resolve(window.wx);
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

/**
 * 设置微信分享内容
 * @param {Object} options 分享选项
 * @param {string} options.title 分享标题（长，用于卡片）
 * @param {string} options.uiTitle UI 标题（短，用于标签页和 Header）
 * @param {string} options.desc 分享描述
 * @param {string} options.link 分享链接
 * @param {string} options.imgUrl 分享图标
 */
export const SHARE_TEMPLATE = (name = '') => `${name}${name ? ' ' : ''}我在夏天艺术工作室，遇见更好的我们 😄😄`;

export const setWeChatShare = async (options = {}) => {
  try {
    const wx = await loadWxSDK();
    
    // 默认配置
    const config = {
      title: options.title || '我在夏天艺术工作室，遇见更好的我们 😄😄',
      desc: options.desc || '在艺术的阳光下，像夏日一样茁壮成长。',
      link: options.link || window.location.href,
      imgUrl: options.imgUrl || `${window.location.origin}/share-logo.png`,
      ...options
    };

    // 1. 更新页面 Title
    const finalTitle = options.uiTitle || config.title || '夏天艺术工作室';
    document.title = finalTitle;

    // 2. 更新 Meta 标签 (用于微信、浏览器分享抓取)
    const updateMeta = (nameOrProperty, content, isProperty = true) => {
      const selector = isProperty ? `meta[property="${nameOrProperty}"]` : `meta[name="${nameOrProperty}"]`;
      let meta = document.querySelector(selector);
      if (!meta) {
        meta = document.createElement('meta');
        if (isProperty) meta.setAttribute('property', nameOrProperty);
        else meta.setAttribute('name', nameOrProperty);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // 基础 Meta
    updateMeta('description', config.desc, false);
    
    // Open Graph (微信/QQ/Facebook)
    updateMeta('og:title', config.title);
    updateMeta('og:description', config.desc);
    updateMeta('og:image', config.imgUrl);
    updateMeta('og:url', config.link);
    updateMeta('og:type', 'website');

    // Schema.org (Google/部分移动浏览器)
    updateMeta('name', config.title, false);
    updateMeta('image', config.imgUrl, false);

    // 3. 更新 Body 中隐藏的图片 (微信抓取兜底方案)
    // 微信有时会抓取页面中第一张可见或隐藏的图片
    let hiddenImg = document.getElementById('wx-share-fallback');
    if (!hiddenImg) {
      const container = document.createElement('div');
      container.id = 'wx-share-fallback-container';
      container.style.cssText = 'display:none; position:absolute; top:-9999px; left:-9999px;';
      hiddenImg = document.createElement('img');
      hiddenImg.id = 'wx-share-fallback';
      container.appendChild(hiddenImg);
      document.body.insertBefore(container, document.body.firstChild);
    }
    hiddenImg.src = config.imgUrl;

    // 4. 尝试配置微信 JS-SDK (如果将来有签名支持，这里会自动生效)
    wx.ready(() => {
      // 分享给朋友
      wx.updateAppMessageShareData({
        title: config.title,
        desc: config.desc,
        link: config.link,
        imgUrl: config.imgUrl,
        success: () => console.log('WeChat share data set success')
      });
      
      // 分享到朋友圈
      wx.updateTimelineShareData({
        title: config.title,
        link: config.link,
        imgUrl: config.imgUrl,
        success: () => console.log('WeChat timeline data set success')
      });
    });

  } catch (error) {
    console.warn('Failed to load WeChat SDK or set share data:', error);
  }
};
